module.exports = __webpack_public_path__ + "static/media/ratingscale_inactive.a9df00f8.svg";